export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";